import React, { useState } from 'react'
import InnerHaeder from '../Component/InnerHaeder'
import Highlights from '../Component/Highlights'
import Footer from '../Component/Footer'
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Link } from 'react-router-dom'
import HeadTag from '../Component/HeadTags'
import LazyLoad from 'react-lazyload';
const OurAchievements = () => {

  return (
    <>
      <HeadTag title="Our Achievements" />
      <Highlights />
      <InnerHaeder />
      <div className="inner_page">
        <div className="container-fluid flwidth achivemnt_sec">
          <div className="bgimage">
            <h5><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link><span>  About Us <i className="fas fa-angle-right"></i>  Our Achievements</span></h5>
            <h2>Our Achievements</h2>
          </div>
          <Tabs className="Tabs">
            <TabList>
              <Tab>2025 - 26</Tab>
              <Tab>2024 - 25</Tab>
              <Tab>2022 - 23</Tab>
              <Tab>2021 - 22</Tab>
              <Tab>2020 - 21</Tab>
              <Tab>2019 - 20</Tab>
              <Tab>2018 - 19</Tab>
            </TabList>
            <TabPanel>
              <div class="row">



                <div class="col-lg-12 col-md-12">
                  <div class="achievementbox no-scroll">
                    <div class="main">
                      <p><b>Lotus Valley International School, Noida Extension, Proves Its Mettle Yet Again!</b> </p>

        <p>Lotus Valley International School, Noida Extension, Proves Its Mettle Yet Again!

Lotus Valley International School, Noida Extension, continues to shine with another remarkable achievement — securing the 2nd position among the Best Day Co-Ed Schools in Greater Noida, and proudly holds Rank 33 in Delhi-NCR and Rank 50 across India, reaffirming its commitment to excellence in education and holistic development.

The CFore (Centre for Forecasting and Research) rankings, developed in collaboration with EducationWorld and Brainfeed, are among the most prestigious evaluations of schools in India, recognising outstanding performance across multiple parameters.

This milestone stands as a proud moment for the entire Lotus Valley community — a reflection of its unwavering dedication, visionary leadership, and collective pursuit of nurturing future-ready learners.

#LotusValleyNoidaExtension <br/>
#SchoolExcellence<br/>
#ProudMoment<br/>
#EducationLeadership<br/>
#FutureReadyLearners<br/>
#TopRankedSchool<br/>
#HolisticEducation</p>

                      <div className='row'>
                        <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGN/public/Images/achievement-27-11-25.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                        </div>
                             <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGN/public/Images/achievement-17-11-25.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                        </div>
                
                      </div>
                    </div>
                    <div class="clr"></div>
                  </div>
                </div>

                <div class="col-lg-12 col-md-12">
                  <div class="achievementbox no-scroll">
                    <div class="main">
                      <p><b>Top Co-Ed Day School in Greater Noida</b> </p>
                      <p> Lotus Valley International School, Noida Extension, has achieved a remarkable milestone by being ranked No. 5 among Co-Ed Day Schools in Greater Noida by EducationWorld India School Rankings 2025–26. The prestigious recognition was conferred at a grand ceremony held at Hotel Pullman, Aerocity, New Delhi. This stellar accomplishment, under the visionary leadership of Principal Ms. Indu Yadav, stands as a proud testament to the school’s relentless pursuit of excellence, holistic education, and strong value-based learning. Heartiest congratulations to the entire Lotus Valley family on this momentous achievement! Together, we continue to inspire, innovate, and excel.</p>

                      <div className='row'>
                        <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGN/public/Images/Top-Co-Ed-1.jpeg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                        </div>
                        <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                          <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/Top-Co-Ed-2.jpeg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                        </div>
                        <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                          <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/Top-Co-Ed-3.jpeg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                        </div>

                      </div>
                    </div>
                    <div class="clr"></div>
                  </div>
                </div>

                <div class="col-lg-12 col-md-12">
                  <div class="achievementbox no-scroll">
                    <div class="main">
                      <p><b> “Education is the most powerful weapon which you can use to change the world.” – Nelson Mandela</b> </p>
                      <p> Lotus Valley International School, Noida Extension is overjoyed to be crowned with the Best School Award for Excellence in Learning & Assessment at the North India School Merit Awards 2025 by Education Today on Friday, 12 September, 2025. This recognition marks yet another milestone in our journey of nurturing brilliance and building a culture of innovation. </p>
                      <p> From over 1,200 schools across North India, only 300 pioneers in education were chosen, and we are proud to shine among them. This victory stands as a testimony to our pursuit of academic brilliance, innovative learning practices, and holistic growth. It reinforces our commitment to shaping young learners who are confident, compassionate, and future-ready. </p>
                      <p> This achievement has been made possible by the inspiring leadership of our Principal, Ms. Indu Yadav, the tireless dedication of our teachers, the unyielding zeal of our students, and the unwavering trust of our parent community. The award strengthens our determination to continue raising the bar, inspiring excellence, and creating an environment where every child blossoms into their best self. Together, we stride ahead with pride and purpose. </p>
                      <p><b>#proudmoment #excellenceineducation #lvisne #northindiaschoolmeritaward</b></p>
                      <div className='row'>

                        <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGN/public/Images/Education16-25-2.jpeg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                        </div>
                        <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                          <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/Education16-25-3.jpeg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                        </div>
                        <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                          <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/Education16-25-4.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                        </div>

                      </div>
                    </div>
                    <div class="clr"></div>
                  </div>
                </div>
                <div class="col-lg-12 col-md-12">
                  <div class="achievementbox no-scroll">
                    <div class="main">
                      <p><b>Mind Mingle’s Indo-Norway International Education Summit and Awards 2025</b> </p>
                      <p>Lotus Valley International School Noida Extension, proudly shines on the global stage as it receives the prestigious Transformative Value-Based Education Excellence Award at Mind Mingle’s Indo-Norway International Education Summit and Awards 2025, held in Oslo, Norway, from August 26–30, 2025. This remarkable honour celebrates the school's unwavering commitment to nurturing future-ready learners, deeply rooted in compassion, character, and strong human values—hallmarks of true education that go beyond academics.</p>
                      <p>Elevating this moment to even greater heights, the Principal, Ms. Indu Yadav, proudly represented LVISNE on this prestigious global stage. On 28 August, at the iconic Stortinget, Parliament of Norway, she presented her visionary ideas on Value Education, leaving an indelible mark on an international audience and showcasing the school’s unwavering commitment to holistic value-based education.</p>
                      <p>This achievement stands as a powerful testament to our belief that education is not merely about imparting knowledge, but about nurturing character, compassion, and the values that shape lives. </p>

                      <div className='row'>

                        <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGN/public/Images/indo-norway-summit-1.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                        </div>

                        <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                          <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/indo-norway-summit-3.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                        </div>
                      </div>
                    </div>
                    <div class="clr"></div>
                  </div>
                </div>
                <div class="col-lg-12 col-md-12">
                  <div class="achievementbox no-scroll">
                    <div class="main">
                      <p><b>Shaping Future-Ready Learners</b> </p>
                      <p>Lotus Valley International School, Noida Extension Honoured for Shaping Future-Ready Learners Education is not the filling of a pail, but the lighting of a fire — and Lotus Valley NE has lit a thousand flames of curiosity. In a proud and momentous recognition, Lotus Valley International School, Noida Extension was felicitated by LogIQids for its outstanding contribution towards nurturing 21st-century skills in students. The honour was conferred at the prestigious ReThinkED – A Leadership Un-Conference & Felicitation Ceremony held on Thursday, 28 August 2025, in New Delhi. This accolade stands as a shining testament to the visionary leadership of Principal, Ms. Indu Yadav, under whose inspiring guidance the school continues to empower young learners with the essential skills of critical thinking, creativity, collaboration, and problem-solving. The recognition is also a reflection of the unwavering dedication of the teachers and the vibrant spirit of the students, who together make learning a joyful and transformative journey at Lotus Valley NE. With this achievement, the school once again reinforces its commitment to creating global citizens who are prepared to lead with wisdom, innovation, and compassion.
                      </p><p>#LVISNE #ProudMoment #FutureReadyLearners #ExcellenceInEducation #LeadershipInLearning</p>

                      <div className='row'>

                        <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGN/public/Images/shape-future1.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                        </div>
                        <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                          <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/shape-future2.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                        </div>
                        <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                          <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/shape-future3.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                        </div>
                      </div>
                    </div>
                    <div class="clr"></div>
                  </div>
                </div>
                <div class="col-lg-12 col-md-12">
                  <div class="achievementbox no-scroll">
                    <div class="main">
                      <p><b>Celebrating a Global Milestone at LVISNE!</b> </p>
                      <p>Guided by the visionary leadership of<b> Ms. Indu Yadav, </b>Lotus Valley International School, Noida Extension, proudly celebrates the achievement of the<b> prestigious British Council RIDS Certification </b>— the result of<b> 12 months of meticulous planning, seamless execution, and immersive learning.</b></p>
                      <p>Through <b>seven transformative projects</b> — including <b>three international collaborations </b>with partner schools in Bahrain and the UK and<b> four innovative in-house initiatives</b> — our school community embraced global perspectives with unmatched enthusiasm and purpose.</p>
                      <p>This enriching journey has empowered<b> teachers, students, and parents alike,</b> embedding <b>skills, values, and attitudes</b> that will continue to shape our curriculum and teaching practices in the years ahead.</p>
                      <p>We extend our <b> heartfelt congratulations to every stakeholder of the LVISNE family</b> for this  <b>remarkable achievement </b>— a shining testament to our collective spirit of<b> innovation, collaboration, and global citizenship.</b></p>
                      <p><b>#LVISPride #BritishCouncilRIDS #GlobalLearning #InnovationInEducation #LVISNEAchieves</b></p>

                      <div className='row'>

                        <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGN/public/Images/rids1.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                        </div>
                        <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                          <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/rids2.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                        </div>
                      </div>
                    </div>
                    <div class="clr"></div>
                  </div>
                </div>
                <div class="col-lg-12 col-md-12">
                  <div class="achievementbox no-scroll">
                    <div class="main">
                      <p>We are elated to announce that <b>Lotus Valley International School, Noida Extension</b> has been honoured with the <b>Educational Excellence Award 2025</b> by the <b>National School Awards.</b><br />
                        This prestigious recognition stands as a testament to the <b>persistent efforts, dedication, and collective commitment</b> of our entire school community.<br />
                        We extend our heartfelt gratitude to our educators, students, parents, and stakeholders whose unwavering support made this achievement possible.
                        <b>Together, we remain committed to the pursuit of excellence in education.</b>
                        <br />
                        #EducationalExcellence #LVISNEPride #NationalSchoolAwards2025 #CommitmentToExcellence #ProudAchievement

                      </p>
                      <div className='row'>

                        <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGN/public/Images/award1.jpeg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                        </div>
                        <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                          <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/award2.jpeg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                        </div>
                        <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGN/public/Images/award3.jpeg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                        </div>
                        <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGN/public/Images/award4.jpeg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                        </div>
                      </div>
                    </div>
                    <div class="clr"></div>
                  </div>
                </div>
                <div class="col-lg-12 col-md-12">
                  <div class="achievementbox no-scroll">
                    <div class="main">
                      <p>Proud Moment for Lotus Valley International School, Noida Extension! We are delighted to share that our school has been awarded “Best School in Teaching-Learning Practices” at the Top Education Brand of the Year Awards 2025. This recognition celebrates our commitment to excellence, innovation, and student-centered education. Thank you to our dedicated staff, students, and parents for being part of this achievement!
                      </p>
                      <div className='row'>

                        <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGN/public/Images/best-school-1-2025.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                        </div>
                        <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                          <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/best-school-2-2025.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                        </div>
                      </div>
                    </div>
                    <div class="clr"></div>
                  </div>
                </div>

              </div>
            </TabPanel>
            <TabPanel>
              <div class="row">


                <div class="col-lg-12 col-md-12">

                  <div class="achievementbox no-scroll">
                    <div class="main">
                      <p><b>Educational Excellence Award</b> by GSLC SPARC School on 13th January 2024.<br></br>Principal of the Year 2024’ at the 10th Eduleaders Summit &amp; Awards on January 22, 2024, by the Universal Mentors Association powered by Brain Wonders.
                      </p>
                      <div className='row'>

                        <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGN/public/Images/award-13-01-2024-1.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                        </div>
                        <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                          <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/award-13-01-2024-2.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                        </div>
                        <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                          <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGN/public/Images/award-13-01-2024-3.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                        </div>
                        <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                          <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/award-13-01-2024-4.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                        </div>
                      </div>
                    </div>

                    <div class="clr"></div>
                  </div>
                </div>

                <div class="col-lg-12 col-md-12">
                  <div class="achievementbox no-scroll">
                    <div class="main">
                      <p><b>Outstanding Principal</b> of the Year by the Economic Times Education Excellence Awards ‘24<br></br><b>Best School</b> for Innovation in Pedagogical Initiatives by the Economic Times Education Excellence Awards ‘24</p>
                    </div>
                    <div className='row'>

                      <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                        <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/award-18-09-2024-1.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                      </div>
                      <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                        <LazyLoad>    <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/award-18-09-2024-2.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                      </div>
                      <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                        <LazyLoad>   <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/award-18-09-2024-3.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                      </div>
                      <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                        <LazyLoad>   <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/award-18-09-2024-4.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                      </div>
                    </div>


                    <div class="clr"></div>
                  </div>
                </div>
              </div>
            </TabPanel>

            <TabPanel>
              <div class="row">
                <div class="col-lg-4 col-md-6">
                  <div class="achievementbox no-scroll ">
                    <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/award-13-10-2023.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>

                    <div class="main">
                      <p><b>‘The Leading Co-ed Day School Award’ </b> for the Greater Noida region, Education World India School Ranking on 13.10.2023.</p>
                    </div>
                    <div class="clr"></div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6">
                  <div class="achievementbox no-scroll">
                    <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGN/public/Images/global-edu-award.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>

                    <div class="main">
                      <p><b>Global Educator Award</b> for Promoting academic Excellence 2022-23 by International Olympiad Foundation (IOF) (for Session 2022-23)</p>
                    </div>
                    <div class="clr"></div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6">
                  <div class="achievementbox no-scroll">
                    <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGN/public/Images/special-merit-award.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>

                    <div class="main">
                      <p><b>Special Merit Award</b> for Digital Innovation Award by Education World Learning Exposition 2023 (for Session 2022-23)</p>
                    </div>
                    <div class="clr"></div>
                  </div>
                </div>

              </div>
            </TabPanel>

            <TabPanel>
              <div class="row">
                <div class="col-lg-6 col-md-6">
                  <div class="achievementbox">
                    <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/award-02-04-2022.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>

                    <div class="main">
                      <p>LVISNE was honoured with the award for <b> ‘Best Experiential Learning Implementation in School’</b> at the Experiential Learning Awards 2022.</p>
                    </div>
                    <div class="clr"></div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4">
                  <div class="achievementbox">
                    <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/award-21-11-2022.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>

                    <div class="main">
                      <p>Manifesting Inspiration - <b>‘SDG Hero by Global Sustainability Awards – 2022’</b>.</p>
                    </div>
                    <div class="clr"></div>
                  </div>
                </div>
              </div>
            </TabPanel>

            <TabPanel>
              <div class="row">
                <div class="col-lg-6 col-md-6">
                  <div class="achievementbox">

                    <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGN/public/Images/award-21-09-2021.png" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>

                    <div class="main">
                      <p><b>ICONIC WOMEN LEADER AWARD-2021, BY ASIA GCC AWARDS</b><br />It gives us immense pleasure to share that, Ms. Indu Yadav, Principal, Lotus Valley International School, Noida Extension has been conferred the Iconic Women Leader Award-2021, by ASIA GCC Awards in the category of Education. The forum felicitated women achievers from diverse fields of Medicine, Aviation, Health Care, Environment, Entrepreneurship and Education, in a virtual ceremony held on September 4, 2021. <br />
                        The school is honoured and proud of Mrs. Yadav’s accomplishment. </p>
                    </div>
                    <div class="clr"></div>
                  </div>
                </div>

                <div class="col-lg-4 col-md-4">
                  <div class="achievementbox">
                    <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGN/public/Images/award-03-03-2020.jpeg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>

                    <div class="main">
                      <p>"Lotus Valley International School, Noida Extension has added another feather to the cap by winning the award for “Best School in Teaching- Learning Practices” at the Indian Excellence in Education Awards 2020 on 29.02.2020 organized by My Brand Better."</p>
                    </div>
                    <div class="clr"></div>
                  </div>
                </div>
              </div>
            </TabPanel>

            <TabPanel>
              <div class="achievementbox no-scroll">
                <div class="main">
                  <p><b>Top 100 Effective Principal Award</b>-2019 by AKS Education Award</p>
                  <div className='row'>

                    <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                      <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/AKS-1.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                    </div>
                    <div className='col-xxl-3 col-lg-3 col-md-6 col-sm-6-col-xs-12'>
                      <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/AKS-2.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                    </div>
                  </div>
                </div>

                <div class="clr"></div>
              </div>
              <div class="row">

                <div class="col-lg-4 col-md-4">
                  <div class="achievementbox">
                    <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/award-26-02-2020.jpeg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>

                    <div class="main">
                      <p>"LVIS, NE has been recognised as the "Best Emerging CBSE School in Innovative Practices, Co-Curricular Activities & Life Skill Education" by Brainfeed School Excellence Awards for the academic session 2019-20."</p>
                    </div>
                    <div class="clr"></div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4">
                  <div class="achievementbox">
                    <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/award-28-01-2020-1.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>

                    <div class="main">
                      <p>"LVIS NE adds yet another feather to its already adorned cap by winning the award for being an 'Exceptional School in Art Integrated Curriculum' by AKS Global Education Awards"</p>
                    </div>
                    <div class="clr"></div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4">
                  <div class="achievementbox">
                    <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/award-28-01-2020-2.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>

                    <div class="main">
                      <p>"LVIS NE adds yet another feather to its already adorned cap by winning the award for being an 'Exceptional School in Art Integrated Curriculum' by AKS Global Education Awards"</p>
                    </div>
                    <div class="clr"></div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4">
                  <div class="achievementbox">
                    <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/award-21-01-2020-1.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>

                    <div class="main">
                      <p>Lotus Valley International School, Noida Extension has been awarded as ‘Best Upcoming CBSE School 2019-20 awarded by India Merit School award’  by Education Today.</p>
                    </div>
                    <div class="clr"></div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4">
                  <div class="achievementbox">
                    <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGN/public/Images/award-21-01-2020-2.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>

                    <div class="main">
                      <p>Lotus Valley International School, Noida Extension has been awarded as ‘Best Upcoming CBSE School 2019-20 awarded by India Merit School award’  by Education Today.</p>
                    </div>
                    <div class="clr"></div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4">
                  <div class="achievementbox">
                    <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/award23-9-19-2.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>

                    <div class="main">
                      <p>Lotus Valley International School, Noida Extension has been awarded as ‘Most Innovative Pedagogical Practices in Noida Extension’ by India Education Awards 2019. </p>
                    </div>
                    <div class="clr"></div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4">
                  <div class="achievementbox">
                    <div class="imgdiv">
                      <LazyLoad>  <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/award23-9-19.jpg" width="400" height="300" layout="responsive" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                      <LazyLoad>     <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/award23-9-19-1.jpg" width="400" height="300" layout="responsive" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                    </div>
                    <div class="main">
                      <p>Lotus Valley International School, Noida Extension has been awarded as ‘Most Innovative Pedagogical Practices in Noida Extension’ by India Education Awards 2019. </p>
                    </div>
                    <div class="clr"></div>
                  </div>
                </div>
              </div>
            </TabPanel>

            <TabPanel>
              <div class="row">
                <div class="col-lg-4 col-md-4">
                  <div class="achievementbox">
                    <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGN/public/Images/award25-4-19.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>

                    <div class="main">
                      <p>High Performing School of 2018 by AKS Education Awards on 25 February, 2019. </p>
                    </div>
                    <div class="clr"></div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4">
                  <div class="achievementbox">
                    <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGN/public/Images/award-1-2-19.png" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>

                    <div class="main">
                      <p> Best School for Academic Excellence’ by Go4Reviews-School <strong>Brainer School Excellence Award 2018</strong></p>
                    </div>
                    <div class="clr"></div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4">
                  <div class="achievementbox">
                    <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGN/public/Images/award2-1-2-19.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>

                    <div class="main">
                      <p>"Lotus Valley International School, Noida Extension awarded as the Best CBSE School in Co-Curricular Activities &amp; Innovative Practices by Brainfeed <strong>School Excellence Awards 2018-19</strong>"</p>
                    </div>
                    <div class="clr"></div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4">
                  <div class="achievementbox">
                    <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGN/public/Images/award3-1-2-19.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>

                    <div class="main">
                      <p>"Lotus Valley International School, Noida Extension awarded as the Best CBSE School in Co-Curricular Activities &amp; Innovative Practices by Brainfeed <strong>School Excellence Awards 2018-19</strong>"</p>
                    </div>
                    <div class="clr"></div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4">
                  <div class="achievementbox">
                    <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGN/public/Images/topcbse.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>

                    <div class="main">
                      <p>"The school has been awarded as Top CBSE School in Uttar Pradesh for <strong>‘Individual Attention to Students’</strong> by Education Today. "</p>
                    </div>
                    <div class="clr"></div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4">
                  <div class="achievementbox">
                    <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGN/public/Images/achv-award.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>

                    <div class="main">
                      <p>"The school has been awarded as Top CBSE School in Uttar Pradesh for <strong>‘Individual Attention to Students’</strong> by Education Today. "</p>
                    </div>
                    <div class="clr"></div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4">
                  <div class="achievementbox">
                    <div class="imgdiv">
                      <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/awarimg.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                      <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGN/public/Images/awarimg1.jpg" class="img-fluid" alt="Lotus Valley International School, Greater Noida" /></LazyLoad>
                    </div>
                    <div class="main">
                      <p> Lotus Valley International School, Noida Extension has been awarded as the <strong>‘Best Emerging School in NCR’</strong> by the India Leadership Awards at a ceremony held at Bangalore on 07 October, 2018.</p>
                    </div>
                    <div class="clr"></div>
                  </div>
                </div>
              </div>
            </TabPanel>
          </Tabs>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default OurAchievements
